import moment from "moment";

class EventHistory {
	/**
	 * @param {string} color can be one of primary, success, danger, warning, info, dark
	 * @param {string} icon can be any icon from FeatherIcon component
	 * @param {string} title event title
	 * @param {string} desc event description
	 * @param {string} time event time in human readable format like "25 mins ago"
	 * @param {Array} attributes event attributes like location, attendees, etc.
	 */

	constructor(title = "", desc = "", time = "", event_status_name = "ASSIGNED") {
		this.color = this.generateEventColor(event_status_name);
		this.icon = this.generateEventIcon(event_status_name);
		this.title = title;
		this.desc = desc;
		this.time = time;
	}

	/**
	 * Convert date string to human readable format
	 * @param {string} dateString date string in "YYYY-MM-DD HH:mm:ss" format
	 * @returns {string} human readable date like "25 mins ago"
	 */

	transformDate(dateString) {
		// Extract the date part from the string
		const datePart = dateString.split(" ")[0];
		const timePart = dateString.split(" ")[1].substring(0, 8); // Extract the time part (HH:mm:ss)

		if (!datePart || !timePart) {
			return "";
		}

		// Combine date and time parts into a valid format
		const formattedDateString = `${datePart} ${timePart}`;

		// Parse the formatted date string with moment
		const date = moment(formattedDateString, "YYYY-MM-DD HH:mm:ss");

		// Format the date to a human-readable format
		return date.fromNow();
	}

	formatDateToString(dateString) {
		// Extract the date part from the string
		const datePart = dateString.split(" ")[0];
		const timePart = dateString.split(" ")[1].substring(0, 8); // Extract the time part (HH:mm:ss)

		if (!datePart || !timePart) {
			return "";
		}

		// Combine date and time parts into a valid format
		const formattedDateString = `${datePart} ${timePart}`;

		// Parse the formatted date string with moment
		const date = moment(formattedDateString, "YYYY-MM-DD HH:mm:ss");

		// Format the date to a human-readable format
		return date.format("DD/MM/YYYY HH:mm:ss");
	}

	generateEventIcon(state) {
		switch (state) {
			case "ASSIGNED":
				return "CalendarIcon";
			case "RESCHEDULED":
				return "RefreshCwIcon";
			case "CANCELLED":
				return "SlashIcon";
			case "FINALIZED":
				return "CheckIcon";
			case "IN PROGRESS":
				return "ActivityIcon";
			case "DELAYED":
				return "ClockIcon";
			case "ON THE WAY":
				return "TruckIcon";
			case "SELECTED":
				return "UserCheckIcon";
			case "ON-DEMAND":
				return "UserPlusIcon";
			case "NOT ASSIGNED":
				return "UserMinusIcon";
			default:
				return "ActivityIcon";
		}
	}
	// Generate event color based on event state (status) like "RESCHEDULED", "ASSIGNED", "CANCELLED" etc.
	// return assigned rescheduled canceled finalized in-pro delayed on-the-way selected ondemand
	generateEventColor(state) {
		switch (state) {
			case "ASSIGNED":
				return "assigned";
			case "RESCHEDULED":
				return "rescheduled";
			case "CANCELLED":
				return "canceled";
			case "FINALIZED":
				return "finalized";
			case "IN PROGRESS":
				return "in-progress";
			case "DELAYED":
				return "delayed";
			case "ON THE WAY":
				return "on-the-way";
			case "SELECTED":
				return "selected";
			case "ON-DEMAND":
				return "on-demand";
			case "NOT ASSIGNED":
				return "no-assigned";
			default:
				return "primary";
		}
	}
}

export default EventHistory;
